module.exports = __webpack_public_path__ + "static/media/icon_data-thumb.a53cee79.svg";